import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import {
  addPagination,
  filterReviewsByAuthorAndReview,
  filterReviewsByDate,
  filterReviewsByIsFeatured,
  filterReviewsByPlatform,
  filterReviewsByRating,
  filterReviewsByRelease,
  filterReviewsByVehicle,
  resetPagination,
  setAppId,
} from '../components/RatingsAndReviews/store/slices/slices/reviews.slice';
import { AppReviewsFiltersListenerEffect } from '../effects/app-reviews-filters-listener.effect';

export const appReviewsFiltersListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  appReviewsFiltersListener.startListening({
    matcher: isAnyOf(
      addPagination,
      resetPagination,
      setAppId,
      filterReviewsByAuthorAndReview,
      filterReviewsByVehicle,
      filterReviewsByRelease,
      filterReviewsByPlatform,
      filterReviewsByRating,
      filterReviewsByIsFeatured,
      filterReviewsByDate
    ),
    effect: AppReviewsFiltersListenerEffect,
  });
